import React from 'react';
import { Route, Switch } from 'react-router-dom';

import FeaturesList from 'components/features/feature-list';

import { PATH_FEATURES_LIST } from 'app-constants';
import NotFound from 'components/not-found';

export default function Features() {
  return (
    <>
      <Switch>
        <Route exact path={PATH_FEATURES_LIST} component={FeaturesList} />
        <Route component={NotFound} />
      </Switch>
    </>
  );
}
